<template>
  <div class="fl-sym-px-16 fl-sym-mt-2">
    <!-- -40 -6 45 94 -->
    <img src="@/assets/ring.png" class="fl-sym-content-center fl-sym-mx-auto" alt />

    <div class="fl-sym-px-16">
      <img id="pointer" src="@/assets/pointer1.png" width="24px" class="fl-sym-mx-auto fl-sym--mt-6 fl-sym-needle" :style="{ transform: 'rotate(288deg)'}"/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    priority: {
      default: 1,
      type: Number
    }
  },
  mounted() {
    this.rotatePointer()
  },
  methods: {
    rotatePointer() {
      let self = this;
      setTimeout(function () {
        let pointer = document.getElementById("pointer");
        let rotationval
        console.log(self.priority)
        if (self.priority == 1) {
          rotationval = 318;
        } else if (self.priority == 2) {
          rotationval = 352;
        } else if (self.priority == 3) {
          rotationval = 410;
        } else {
          rotationval = 455;
        }
        pointer.style.transform = 'rotate(' + rotationval + "deg)";
      }, 500);
    }
  }
}
</script>
<style scoped>
.fl-sym-needle{
  /* transform: translateX(-9%); */
  transform-origin: 66.1% 73%;
  transition: 2s all;
}
</style>